import { gql } from 'graphql.macro'

export default gql`
  fragment EventTypeBaseFragment on EventType {
    id
    name
  }
`
